export default [
  {
    path: "/share/schedule/:id",
    name: "ShareSchedule",
    component: () => import(/* webpackChunkName: "share-schedule" */ "@/pages/Share/Schedule/IndexView.vue"),
    meta: { auth: false, layout: 'Simple' }
  }
]